import React from "react";
import "./Socialapp.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faInstagram,
  faTwitter,
  faYoutube,
  faTwitch,
  faLinkedinIn,
  faTiktok,
  faReddit,
  faSnapchatGhost,
  faPinterest,
  faSpotify,
  faDiscord,
} from "@fortawesome/free-brands-svg-icons";
import QuestGridLogo from "../../Images/QuestGridLogo.png";
import { Image } from "react-bootstrap";
import configData from "../../config/config.json";
import onlyfans from "../../Images/onlyfans.png";
import applemusic from "../../Images/applemusic.png";

export default function Socialapp() {
  return (
    <div className="social-container">
      <Image
        className="logo"
        src={QuestGridLogo}
        alt="logo"
        fluid
        width="400" 
        hight="70"
      />

      <p className="mid-text">
        {" "}
        "A decentralized multimedia infrastructural platform."
      </p>
      <div className="social-links">
        <a
          href={configData.YOUTUBE_URL}
          target="_blank"
          rel="noreferrer"
          className=" youtube social"
        >
          <FontAwesomeIcon icon={faYoutube} className="fa-icon"  />
        </a>
        <a
          href={configData.FACEBOOK_URL}
          target="_blank"
          rel="noreferrer"
          className=" facebook social"
        >
          <FontAwesomeIcon icon={faFacebook} className="fa-icon"   />
        </a>
        <a
          href={configData.Twitter_URL}
          target="_blank"
          rel="noreferrer"
          className=" twitter social"
        >
          <FontAwesomeIcon icon={faTwitter} className="fa-icon"   />
        </a>
        <a
          href={configData.INSTAGRAM_URL}
          target="_blank"
          rel="noreferrer"
          className=" insta social"
        >
          <FontAwesomeIcon icon={faInstagram} className="fa-icon"    />
        </a>
        <a
          href={configData.Twitch_URL}
          target="_blank"
          rel="noreferrer"
          className=" twitch social"
        >
          <FontAwesomeIcon icon={faTwitch} className="fa-icon"   />
        </a>
        <a
          href={configData.LINKEDIN_URL}
          target="_blank"
          rel="noreferrer"
          className=" linkedin social"
        >
          <FontAwesomeIcon icon={faLinkedinIn} className="fa-icon"  />
        </a>
        <a
          href={configData.tiktok_URL}
          target="_blank"
          rel="noreferrer"
          className=" tiktok social"
        >
          <FontAwesomeIcon icon={faTiktok} className="fa-icon"   />
        </a>
        <a
          href={configData.Reddit_URL}
          target="_blank"
          rel="noreferrer"
          className=" reddit social"
        >
          <FontAwesomeIcon icon={faReddit} className="fa-icon"   />
        </a>
        <a
          href={configData.Snapchat_URL}
          target="_blank"
          rel="noreferrer"
          className=" snapchat social"
        >
          <FontAwesomeIcon icon={faSnapchatGhost} className="fa-icon"   />
        </a>
        <a
          href={configData.PINTEREST_URL}
          target="_blank"
          rel="noreferrer"
          className=" pinterest social"
        >
          <FontAwesomeIcon icon={faPinterest} className="fa-icon"   />
        </a>
        <a
          href={configData.ONLYFANS_URL}
          target="_blank"
          rel="noreferrer"
          className="onlyfans social"
        >
          <img src={onlyfans} alt="onlyfans" className="social-icon"/>
        </a>
        <a
          href={configData.APPLEMUSIC_URL}
          target="_blank"
          rel="noreferrer"
          className="applemusic social"
        >
          <img src={applemusic} alt="applemusic" className="social-icon"/>
        </a>
        <a
          href={configData.SPOTIFY_URL}
          target="_blank"
          rel="noreferrer"
          className=" spotify social"
        >
          <FontAwesomeIcon icon={faSpotify} className="fa-icon"   />
        </a>
        <a
          href={configData.DISCORD_URL}
          target="_blank"
          rel="noreferrer"
          className=" discord social"
        >
          <FontAwesomeIcon icon={faDiscord} className="fa-icon"   />
        </a>
      </div>
    </div>
  );
}
